import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { selectIsCloudRecordingAvailable } from '../../../../../../pages/call/features/cloud-recording';
import {
    selectHasCloudRecordingBanRolePermission,
    selectHasMembersCloudRecordingPermission,
    setCloudRecordingForMembersAllowed,
} from '../../../../../../pages/call/features/permissions';
import { i18n } from '../../../../../helpers/i18n';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import { SettingsTumbler } from './settings-tumbler';

export const CloudRecordingTumbler: FunctionComponent = () => {
    const isCloudRecordingAvailable = useSelector(selectIsCloudRecordingAvailable);
    const hasBanPermission = useSelector(selectHasCloudRecordingBanRolePermission);
    const hasMembersPermission = useSelector(selectHasMembersCloudRecordingPermission);

    const onChange = useOnPermissionChange(setCloudRecordingForMembersAllowed, 'cloud-recording');

    if (!isCloudRecordingAvailable || !hasBanPermission) {
        return null;
    }

    return (
        <SettingsTumbler
            testId="cloud-recording-tumbler"
            label={i18n('settings-v2', 'permission-ban-cloud-recording')}
            checked={hasMembersPermission}
            onChange={onChange}
        />
    );
};
